"use strict";

var dealerFormsManager = function () {
  var currentVehicle = void 0;
  var _setCurrentVehicle = function _setCurrentVehicle(value) {
    return currentVehicle = value;
  },
      _getCurrentVehicle = function _getCurrentVehicle() {
    return currentVehicle;
  };

  var _init = function _init(vehicleData, area) {
    var arrayVehicles = promoGalp.applyDiscount(vehicleData.dealersVehicles);
    var currentVehicle = arrayVehicles[0];
    _setCurrentVehicle(currentVehicle);
    // Banner Top
    vehicleApp.setCurrentArea(area);
    vehicleApp.setCurrentVehicle(currentVehicle.vehicle);
    vehicleApp.setCurrentPrices(currentVehicle.prices);
    vehicleApp.printTitle(currentVehicle.vehicle.vdisplayModelo);
    vehicleApp.displayGeneralData();
    vehicleApp.displayImages();
    _printBreadCrum(currentVehicle.vehicle);
    _printFinancial(currentVehicle);
  };

  var _printBreadCrum = function _printBreadCrum(vehicle) {
    var modelPath = utils.getDisplayModelName(vehicle.vdisplayModelo).completeName.toLowerCase().replace(" ", "-");
    var modelName = utils.getDisplayModelName(vehicle.vdisplayModelo).completeName;
    var vehiclePath = vehicle.vcodcom17;
    var versionName = vehicle.vgrado;

    $(".js-prev").text(modelName).attr("href", "../../" + modelPath);
    $(".js-prev-2").text(modelName + " " + versionName).attr("href", "../" + vehiclePath);
    $(".js-page").text("Dê o seguinte passo ");
  };

  var _printFinancial = function _printFinancial(currentVehicle) {
    if (sessionStorage.cafi) {
      var cafiData = JSON.parse(sessionStorage.cafi);
      if (cafiData[currentVehicle.vehicle.vcodcom17]) {
        var financialObj = cafiData[currentVehicle.vehicle.vcodcom17];
        $(".js-cafi-cuota").text(utils.formatPrice(financialObj.cuota_financiera, 1));
        $(".js-cafi-open").removeClass("hidden");
      }
    }
  };

  // ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  function _setSelection(codhost, dealername, cp) {
    _showTabs(codhost);

    $(selectors.dlrName).html("O seu concession\xE1rio \xE9 <strong>" + dealername + "</strong>");
    var botonModificar = $("<button/>").text("Modificar").addClass("h-btn grey h-icon editpencil2").on("click", function (event) {
      event.preventDefault();
      _abreConces();
    });
    $(selectors.dlrName).append(botonModificar);
    $(selectors.dlrsContainer).slideUp();
  }

  function _abreConces() {
    _resetForms();
    _hideForms();
    $(selectors.dlrName).text($(selectors.dlrName).attr("data-defecto"));
    $(selectors.dlrsContainer).slideDown("slow");
  }

  var _checkTpvDealer = function _checkTpvDealer(codhost) {
    var matchSelectedInList = dealersData.dealers.filter(function (dealer) {
      return dealer.codHost === codhost;
    });
    console.log("with TPV", matchSelectedInList);
    if (matchSelectedInList.length > 0) {
      if (matchSelectedInList[0].tpvDealer) {
        return true;
      }
    }
    return false;
  };

  var _resetForms = function _resetForms() {
    document.forms.formOffer.reset();
    document.forms.formSale.reset();
  };

  var _hideForms = function _hideForms() {
    $(".js-forms-container").addClass("inactive");
  };

  var _showTabs = function _showTabs(codhost) {
    _resetForms();
    var formOfferParams = {
      selector: "#formOffer",
      dealerType: "general",
      dealerSelect: ".js-field-dealer",
      options: {
        rules: {
          dealer: {
            required: true,
            messages: {
              required: "Campo obrigatório"
            }
          },
          surname1: {
            required: true,
            alphabetical: true,
            messages: {
              required: "Campo obrigatório",
              alphabetical: "Apenas caracteres alfabéticos"
            }
          },
          phone: {
            required: true,
            phonePT: true,
            messages: {
              required: "Campo obrigatório",
              phonePT: "Telefone inválido"
            }
          },
          postalcode: {
            required: true,
            cpPT: true,
            messages: {
              required: "Campo obrigatório",
              cpPT: "Código Postal inválido"
            }
          }
        }
      }
    };
    var requiredTxt = "Campo obrigatório";
    var formSaleParams = {
      selector: "#formSale",
      dealerType: "general",
      dealerSelect: ".js-field-dealer",
      options: {
        rules: {
          dealer: {
            required: true,
            messages: {
              required: requiredTxt
            }
          },
          surname1: {
            required: true,
            alphabetical: true,
            messages: {
              required: requiredTxt,
              alphabetical: "Sólo caracteres alfabéticos"
            }
          },
          surname2: {
            required: true,
            alphabetical: true,
            messages: {
              required: requiredTxt,
              alphabetical: "Sólo caracteres alfabéticos"
            }
          },
          phone: {
            required: true,
            phonePT: true,
            messages: {
              required: requiredTxt,
              phonePT: "Teléfono móvil no válido"
            }
          },
          nif: {
            required: true,
            ccOrBi: true,
            messages: {
              required: requiredTxt,
              ccOrBi: "Cartão de Cidadão inválido"
            }
          },
          postalcode: {
            required: true,
            cpPT: true,
            messages: {
              required: requiredTxt,
              cpPT: "Código postal inválido"
            }
          },
          birthdate: {
            required: true,
            dateEsFormat: true,
            messages: {
              required: requiredTxt,
              dateEsFormat: "El formato debe ser dd/mm/aaaa"
            }
          },
          citizenship: {
            required: true,
            messages: {
              required: requiredTxt
            }
          },
          address: {
            required: true,
            messages: {
              required: requiredTxt
            }
          }
        }
      }
    };

    if (_checkTpvDealer(codhost)) {
      $(".js-form-sale-elem").removeClass("hidden");
      // $(".js-label-force").removeClass("force-border-left");
      $("#tab_two").prop("checked", false);
      $("#tab_one").prop("checked", true);
      formsApp.init(formSaleParams);
    } else {
      $(".js-form-sale-elem").addClass("hidden");
      // $(".js-label-force").addClass("force-border-left");
      $("#tab_one").prop("checked", true);
    }
    $("*[name=pcodHost]").val(codhost);
    formsApp.init(formOfferParams);

    $(".js-forms-container").removeClass("inactive");
  };

  return {
    init: _init,
    setSelection: _setSelection
  };
}();